<template>
  <div id="top" class="top">
    <picture>
      <source class="top-image" media="(min-width: 980px)" :srcset="pc" />
      <img class="top-image" :src="mobile" alt="top" />
    </picture>
  </div>
</template>

<script>
import pc from '../../assets/images/PCHeaderComponent@4x.png'
import mobile from '../../assets/images/MobileHeaderComponent@4x.png'

export default {
  name: 'Top',
  data() {
    return {
      pc: pc,
      mobile: mobile
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../stylesheets/variables.scss';

.top {
  position: relative;
  margin-bottom: 3%;
}

.top::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 96.1%;
  left: 50%;
  border-width: 2.4vw 5.6vw 0 5.6vw;
  border-style: solid;
  border-color: $white transparent transparent transparent;
  transform: translateX(-50%);
}

.top-image {
  width: 100%;
  height: auto;
}
</style>
